import { useEffect, useRef, useState } from 'react'

export const useGetThumbLoad = (url: string | null): boolean => {
  const [isLoading, setIsLoading] = useState(Boolean(url))
  const cancelledRef = useRef(false)

  useEffect(() => {
    if (!url) {
      setIsLoading(false)
      return
    }
    cancelledRef.current = false
    setIsLoading(true)
    const img = new Image()
    const onDone = () => {
      if (!cancelledRef.current) setIsLoading(false)
    }
    img.onload = onDone
    img.onerror = onDone
    img.src = url
    return () => {
      cancelledRef.current = true
      img.onload = null
      img.onerror = null
      img.src = ''
    }
  }, [url])

  return isLoading
}
